import { addListener } from "@grindex-common/helpers/domManipulation";
import { refreshSlider } from "@grindex-client/components/Slider/slider";

const breaks = [
	{ screen: 0, slides: 1, pager: false },
	{ screen: 660, slides: 2 },
	{ screen: 1280, slides: 3 },
];

function init($views) {
	$views.forEach(($view) => {
		function flipCard(event) {
			// Flip all cards with same data-card value so we flip the cloned ones in carousel as well
			const cardData = event.target.dataset.card;

			$view.querySelectorAll(`[data-card='${cardData}']`).forEach(($card) => {
				$card.classList.toggle("flipped");
			});
		}

		const isFlippableCard = ($element) => $element.classList && $element.classList.contains("flippable-card");

		const isFlippableSlider = () => {
			return Array.prototype.filter.call($view.querySelectorAll("li"), ($li) => {
				Array.prototype.some.call($li.childNodes, isFlippableCard);
			}).length;
		};

		const initCarousel = () => {
			if (!isFlippableSlider()) {
				return;
			}

			var upTime = $view.dataset.pause;
			$view.classList.add("is-slider");

			$($view).bxSlider({
				auto: false,
				breaks: breaks,
				pager: false,
				slideMargin: 20,
				pause: upTime ? upTime * 1000 : 5000,
				autoHover: true,
				autoReload: true,
				useCSS: false,
				shrinkItems: true,
				moveSlides: 4,
				onSliderRedraw: () => {
					refreshSlider($view);
				},
			});

			refreshSlider();
		};

		addListener($view.getElementsByClassName("flip-card"), "click", flipCard);

		initCarousel();
	});
}

export default {
	view: "flippableCard",
	init,
};
